module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon03_hover.5c1a5ae6.svg";